import styles from "./SectionCategories.module.css";
import aboutUsBgImage from "../../assets/images/somos/lineas (1).png";
import servicesIcon20 from "../../assets/images/servicios/Group 20.png";
import servicesIcon23 from "../../assets/images/servicios/Group 23.png";

import iconTop2 from "../../assets/images/servicios/Group 20 (2).png";
import iconTop3 from "../../assets/images/servicios/Group 20 (1).png";
import iconBottom1 from "../../assets/images/servicios/Group 18.png";
import iconBottom2 from "../../assets/images/servicios/Group 46.png";

const SectionCategories = () => {
  return (
    <section
      className={styles.sectionContainer}
      style={{
        backgroundImage: `url(${aboutUsBgImage})`,
      }}
    >
      <div className={styles.cardWrapper}>
        {/* {[1, 2, 3].map((_, idx) => ( */}
        <div className={styles.card}>
          {/* Icono superior centrado */}
          <img
            src={servicesIcon20}
            alt="Ícono superior"
            className={styles.cardIcon}
            loading="lazy"
          />

          {/* Icono decorativo encima al centro */}

          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>Publicidad</div>
            <div className={styles.cardDescription}>
              Estrategia publicitaria implementada en publicaciones bimestrales
              de las revistas El Industrial y Tracto y Buses de Guadalajara.
            </div>
          </div>
          <img
            src={iconBottom1}
            alt="Decorativo"
            className={styles.cardOverlayIcon}
            loading="lazy"
          />
        </div>

        <div className={styles.card}>
          {/* Icono superior centrado */}
          <img
            src={iconTop2}
            alt="Ícono superior"
            className={styles.cardIcon}
            loading="lazy"
          />

          {/* Icono decorativo encima al centro */}

          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>Diseño</div>
            <div className={styles.cardDescription}>
              Creación y diseño gráfico de anuncios publicitarios para
              publicaciones bimestrales en El Industrial y Tracto y Buses de
              Guadalajara.
            </div>
          </div>
          <img
            src={iconBottom2}
            alt="Decorativo"
            className={styles.cardOverlayIcon}
            loading="lazy"
          />
        </div>

        <div className={styles.card}>
          {/* Icono superior centrado */}
          <img
            src={iconTop3}
            alt="Ícono superior"
            className={styles.cardIcon}
            loading="lazy"
          />

          {/* Icono decorativo encima al centro */}

          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>Promoción</div>
            <div className={styles.cardDescription}>
              Nuestras revistas cuentan con cobertura a nivel nacional,
              presentes en exposiciones del sector transporte y manufactura.
            </div>
          </div>
          <img
            src={servicesIcon23}
            alt="Decorativo"
            className={styles.cardOverlayIcon}
            loading="lazy"
          />
        </div>
        {/* ))} */}
      </div>
    </section>
  );
};

export default SectionCategories;
